import React from 'react';
import styles from './FirstPage.module.css';

import { confirmAlert } from 'react-confirm-alert';
import Nutzungsinfos from './Nutzungsinfos';

function FirstPage({ clearAnswers, setAnswers, intro, isEligible, isLoggedIn, usageCount, availableUses }) {

  const submit = () => {
    confirmAlert({
      title: 'Antwort-Löschung',
      message: 'Sind Sie sicher, dass Sie die bisherigen Antworten löschen möchten?',
      buttons: [
        {
          label: 'Ja',
          onClick: () => clearAnswers()
        },
        {
          label: 'Nein',
          onClick: () => { }
        }
      ]
    });
  };

  return <div className={styles.FirstPage}>
    <h2 className={styles.FirstPageHeader}>Willkommen beim Datenschutzgenerator!</h2>
    <p className={styles.FirstPage_p}>{intro}</p>
    <hr></hr>
    <Nutzungsinfos isEligable={isEligible} isLoggedIn={isLoggedIn} availableUses={availableUses} usageCount={usageCount} />
    {/* <hr></hr>
    <p className={styles.FirstPage_p}>Du hast den Generator schon einmal benutzt, möchtest aber ganz von vorne anfangen?</p>
    <p className={styles.FirstPage_p}>Mit diesem Button kannst du alle deine Antworten zurücksetzen.</p> */}
    {/* <button onClick={submit}>Bisherige Antworten löschen</button> */}

  </div>
}


export default FirstPage;